/**
 * pipelineAnomaly.js — Phase G · Active Anomaly Alerting
 *
 * Pure, dependency-free helper that consumes the
 * `/api/admin/pipeline-stats` payload and derives anomaly flags for
 * the sidebar dot + banner tooltip warning block.
 *
 * Kept in `lib/` (not inside the React hook) so it stays trivially
 * importable from Jest tests under create-react-app's default Jest
 * config — no `@/` alias resolution needed.
 *
 * Anomaly signals:
 *   1. modal.has_credentials === false   → code: "credentials_missing"
 *   2. sum(by_kind[*].failed) > 5        → code: "failures_exceed"
 */
export const FAILURE_THRESHOLD_24H = 5;

export function deriveAnomaly(data) {
  if (!data) return { hasAnomaly: false, anomalyReasons: [], failedCount: 0 };
  const reasons = [];
  // EXPLICIT `false` only — undefined/missing must NOT fire (first paint).
  const hasCreds = data?.modal?.has_credentials !== false;
  if (!hasCreds) {
    reasons.push({
      code: "credentials_missing",
      message: "Serverless credentials missing. Pipeline operating in local fallback.",
    });
  }
  const byKind = data?.recent_jobs?.by_kind || {};
  let failed = 0;
  for (const k of Object.keys(byKind)) {
    failed += Number(byKind[k]?.failed || 0);
  }
  if (failed > FAILURE_THRESHOLD_24H) {
    reasons.push({
      code: "failures_exceed",
      message: `${failed} failed jobs in the last 24h (threshold: ${FAILURE_THRESHOLD_24H}).`,
    });
  }
  return { hasAnomaly: reasons.length > 0, anomalyReasons: reasons, failedCount: failed };
}
